import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { find, get, round } from 'lodash';

import {
    getPricingDetails,
    savePlanSelection,
} from '../../store/signup/signupAction';
import Loader from '../../components/Loader';

/**
 * Price Prefill component
 * @param {*} param0
 */
const PricingPreFill = ({ getPricingDetails, savePlanSelection }) => {
    const history = useHistory();
    let { users, volume, flavor } = useParams();

    useEffect(() => {
        getPricingDetails().then((res) => {
            const flavorSelected = find(get(res, 'flavor', []), (elem) => {
                return elem.component_id === parseInt(flavor);
            });

            if (flavorSelected) {
                const monthlyPrice = round(
                    get(res, 'storage.0.scales.0.scale_unitPrice') * volume +
                        get(flavorSelected, 'scales.0.scale_unitPrice', 0) +
                        5 * users,
                    2
                );
                const saveData = {
                    users: users,
                    storage: volume,
                    flavor: {
                        value: flavorSelected.component_id,
                        description: flavorSelected.component_description,
                        label: flavorSelected.component_name,
                        price: get(
                            flavorSelected,
                            'scales.0.scale_unitPrice',
                            0
                        ),
                    },
                    monthlyPrice,
                };
                savePlanSelection(saveData);
                // save flavor and volume config in store
                history.push('/need-domain');
            } else {
                history.push('/404');
            }
        });
    }, [users, volume, flavor, history, getPricingDetails, savePlanSelection]);

    return (
        <div>
            <Loader />
        </div>
    );
};

const mapStateToProps = (store) => ({});
const mapDispatchToProps = {
    getPricingDetails,
    savePlanSelection,
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingPreFill);
